module.exports = __webpack_public_path__ + "static/media/school-login-classroom.30a7ca46.jpg";